/** @jsx jsx */
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Tab, Tabs } from '@blueprintjs/core';
import { PropertyType as SrsPropertyType } from 'srs-middleware';
import { PropertyListSelector } from 'components/selectors/propertyListSelector';
import { MATRIX_SORT_ROWS, MATRIX_SORT_COLS } from './utils.jsx';
import { LimitSelector } from 'components/selectors/limitSelector';
import { EndpointPropertySelector } from 'components/selectors/endpointPropertySelector';
import { EndpointParameterSelector } from 'components/selectors/endpointParameterSelector';
import { AGGREGATION_METHOD_VALUES } from 'widgets/chartUtils';
import CommonKnobsContainer from 'views/common/commonKnobsContainer';

/**
 * Custom renderer for the controls available to change the chart settings.
 *
 * Data Properties for this Widget:
 *   -- propertyList
 *   -- limit
 *
 * Chart Properties for this Widget:
 *
 * @param cardIndex
 * @param endpointQuery
 * @param flags
 * @param widgetConfiguration
 * @returns {*}
 * @constructor
 */
export const MatrixKnobs = ({ cardIndex, endpointQuery, flags }) => {
	return (
		<Tabs>
			<Tab
				id="data"
				title="Data"
				panel={
					<React.Fragment>
						<CommonKnobsContainer>
							<PropertyListSelector
								cardIndex={cardIndex}
								itemIndex={1}
								flags={flags}
								label={'Row'}
								endpointQuery={endpointQuery}
								cy-test="count-by-dropdown-button"
							/>
							<PropertyListSelector
								cardIndex={cardIndex}
								itemIndex={0}
								flags={flags}
								label={'Column'}
								endpointQuery={endpointQuery}
								cy-test="group-by-dropdown-button"
							/>
						</CommonKnobsContainer>
						<CommonKnobsContainer>
							<EndpointParameterSelector
								cardIndex={cardIndex}
								endpointQuery={endpointQuery}
								propertyName="AggregationType"
								label="Aggregation Method"
								values={AGGREGATION_METHOD_VALUES}
								defaultValue={AGGREGATION_METHOD_VALUES[0]}
								isNullable={true}
								cy-test="aggregation-method-dropdown-button"
							/>
							<EndpointPropertySelector
								cardIndex={cardIndex}
								endpointQuery={endpointQuery}
								propertyName="aggregationProperty"
								types={[SrsPropertyType.Numeric]}
								label="Aggregation Property"
								isNullable={true}
								cy-test="aggregation-dropdown-button"
							/>
						</CommonKnobsContainer>
						<CommonKnobsContainer>
							<EndpointParameterSelector
								cardIndex={cardIndex}
								endpointQuery={endpointQuery}
								propertyName="sortRows"
								label="Sort Row By"
								values={MATRIX_SORT_ROWS}
								defaultValue={MATRIX_SORT_ROWS[0]}
								sortIndex={0}
								cy-test="sort-rows-by-dropdown-button"
							/>
							<EndpointParameterSelector
								cardIndex={cardIndex}
								endpointQuery={endpointQuery}
								propertyName="sortColumns"
								label="Sort Column By"
								values={MATRIX_SORT_COLS}
								defaultValue={MATRIX_SORT_COLS[0]}
								sortIndex={0}
								cy-test="sort-cols-by-dropdown-button"
							/>
						</CommonKnobsContainer>
					</React.Fragment>
				}
			/>
			<Tab
				id="style"
				title="Style"
				panel={
					<React.Fragment>
						<CommonKnobsContainer>
							<LimitSelector
								cardIndex={cardIndex}
								endpointQuery={endpointQuery}
								initialLimit={20}
								label={'Number of Rows'}
								limitProperty="maxRows"
								cy-test="row-item-limit-dropdown-button"
							/>
							<LimitSelector
								cardIndex={cardIndex}
								endpointQuery={endpointQuery}
								initialLimit={10}
								label={'Number of Columns'}
								limitProperty="maxColumns"
								cy-test="col-item-limit-dropdown-button"
							/>
						</CommonKnobsContainer>
					</React.Fragment>
				}
			/>
		</Tabs>
	);
};
